import { api } from './client'
import type { AiSummary, AiSummaryBody, FeedbackRating } from '@/types'
import type { CoachingMode } from '@/types/coaching'

export function fetchSummaries(): Promise<AiSummary[]> {
  return api.get('/api/ai-summaries')
}

export function fetchLatestInsights(): Promise<Record<string, string>> {
  return api.get('/api/ai-summaries/latest-insights')
}

export function getCachedSummary(snapshotId: string): Promise<AiSummary | null> {
  return api.get(`/api/ai-summaries/cached/${snapshotId}`)
}

/** How a streamed letter was written: its summarized thinking, the model, and token usage. */
export interface LetterProvenance {
  thinking?: string
  model?: string
  inputTokens?: number
  outputTokens?: number
  /** The typical cost shown before Generate, to compare with the actual cost. */
  estimatedCostUsd?: number
}

export function saveSummary(
  snapshotId: string, coachingMode: CoachingMode, includeFullJournal: boolean, body: AiSummaryBody,
  provenance: LetterProvenance = {},
): Promise<AiSummary> {
  return api.post('/api/ai-summaries', { snapshotId, coachingMode, includeFullJournal, body, ...provenance })
}

export function saveFeedback(id: string, rating: FeedbackRating, note?: string): Promise<void> {
  return api.post(`/api/ai-summaries/${id}/feedback`, { rating, note })
}

export function deleteSummary(id: string): Promise<void> {
  return api.delete(`/api/ai-summaries/${id}`)
}
